import { temporaryNotificationDomainStore } from '../temporary-store/store';
export const hasNotification = (id) => {
    return !!temporaryNotificationDomainStore.data.notifications.find(notification => notification.id === id);
};
